import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { OrderBatchLogisticsWizardService } from 'src/app/services/wizard/logistic/order-batch-send-wizard.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { OrderBatchItem } from '../../../../model/logistics/order/index';
import { NotificationToastService } from '../../../../services/notification-toast.service';

@Component({
  selector: 'app-send-order-logistics-item',
  templateUrl: './send-order-logistics-item.component.html',
  styleUrls: ['./send-order-logistics-item.component.css']
})
export class SendOrderLogisticsItemComponent implements OnInit, WizardStep {

    form: FormGroup;
    loading: boolean;
    isInit: boolean;
    @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
    displayColumns = ['Protocol', 'buttons'];
    dataSource = new BehaviorSubject<AbstractControl[]>([]);

  constructor(private orderBatchSendWizardService: OrderBatchLogisticsWizardService
    , private notificationToastService: NotificationToastService
    , private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      OrderBatchItems: this.formBuilder.array([]),
      NewProtocol: ['']
    });
  }

  get completed(): boolean { return true; }
  get orderBatchItemsForm() { return <FormArray>this.form.get('OrderBatchItems'); }

  ngOnInit(): void {
    this.isInit = true;
  }

  get valid(): boolean {
    return this.completed;
  }


  activate(): void {
    const items = this.orderBatchSendWizardService.getOrderBatchItems();
    this.addItems(items);
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  private addItems(items: OrderBatchItem[]) {
    this.form.controls.OrderBatchItems = this.formBuilder.array([]);
    items.forEach((item) => {
      const row = this.formBuilder.group({
        Protocol: [item.Protocol],
        Id: [item.Id],
        OrderId: [item.OrderId],
        OrdenBatchId: [item.OrdenBatchId],
        Guide: [item.Guide],
      });
      this.orderBatchItemsForm.push(row);
      this.dataSource.next(this.orderBatchItemsForm.controls);
    });
  }

  save(): void {
  }

  async addProtocol() {
    try {
      if (this.form.controls.NewProtocol.value !== '') {
        this.loading = true;
        const items = await this.orderBatchSendWizardService.addProtocol(this.form.controls.NewProtocol.value);
        this.addItems(items);
      } else {
        this.notificationToastService.error('Debe ingresar el protocolo', 'Envio de órdenes');
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Envio de órdenes');
    } finally {
      this.form.patchValue({ NewProtocol: ''});
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
      this.loading = false;
    }
  }

  deleteProtocol(index: number): void {
    this.orderBatchSendWizardService.removeOrderBatchItem(index);
    this.orderBatchItemsForm.removeAt(index);
    this.dataSource.next(this.orderBatchItemsForm.controls);
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  displayProtocol(index: number): string {
    return this.orderBatchItemsForm.controls[index].value.Protocol;
  }
}
